/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowTravelTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowTravel,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Adventure Awaits!",
    "Let's Go Exploring!",
    "Plan Our Trip!",
  ],
  title: "Travel",
  description: "Organize your next adventure with ease.",
  longDescription:
    "Plan every detail of your upcoming travel experience. Select dates, choose the perfect destination, manage expenses, and keep everyone in the loop!",
  emoji: "🌍",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Travel,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Travel",
          emoji: "🌍",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When are we traveling?",
          emoji: "📅",
          completeAction: {
            question: "Choose a destination?",
            description: "Let’s pick the perfect place for our adventure!",
            addModules: [
              {
                type: ModuleType.Location,
                doneType: ModuleDoneType.Voting,
                title: "Where should we go?",
                emoji: "📍",
                completeAction: {
                  question: "Plan activities?",
                  description:
                    "Decide on the activities and sights to explore.",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.None,
                      title: "What activities should we do?",
                      emoji: "🗺",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Bon Voyage!",
    outroDescription:
      "Your travel plans are all set! Get ready for an unforgettable journey!",
  },
};
